import styled, { css } from 'styled-components';
import { color, fontWeight, mediaQuery } from './services/settings.json';
import utils from './services/utils';

const { getFontSize } = utils;

export const Title = styled.h1`
	${getFontSize(20)}
	font-weight: ${fontWeight.medium};
	font-family: 'Poppins', sans-serif;
	margin: 0;
	margin-bottom: 20px;
`;


export const LastProductInfo = styled.div`
	width: fit-content;
	display: flex;
	font-family: 'Poppins', sans-serif;
	flex-direction: column;
	margin: 0;

	> svg {
		width: 48px;
		height: 48px;
	}

	> em {
		${getFontSize(16)}
		margin: 16px 0 0 0;
		min-height: 65px;
        font-style: normal;
	}

	@media (max-width: 1919px) {
		flex: 1;
		margin: 0 30px 0 0;

		> em {
			padding: 0 36px 0 0;
		}

		:first-child{
			margin: 0 66px 0 0;
			> em {
				padding: 0;
			}
		}

		:last-child{
			margin: 0;
			> em {
				padding: 0;
			}
		}
	}
`;

export const Content = styled.div`
	font-weight: ${fontWeight.bold};
	color: ${color.light};
	font-family: 'Poppins', sans-serif;
	display: flex;
	align-items: center;

	em {
		font-size: 16px;
		font-weight: ${fontWeight.bold};
		margin-left: 20px;
	}

	p {
		font-size: 16px;
		color: ${color.light};
		font-weight: ${fontWeight.medium};
		margin-left: 10px;
		line-height: 16px;
	}

	span {
		font-size: 60px;
		color: ${color.light};
		font-weight: ${fontWeight.bold};
		line-height: 20px;
		&.viewers {
			margin-top: 40px;
		}
	}

`;

export const RecordVideoLink = styled.a`
	display: flex;
	flex-direction: row;
	align-items: center;
	${({ noVideo }) => noVideo && 'pointer-events: none;'}

	> span {
		${({ noVideo }) => `
			color: ${noVideo ? color.gray : color.dark};
			cursor: ${noVideo ? 'default' : 'pointer'};
		`}
		
		:hover {
			opacity: .8;
		}
	}

	> svg {
		height: 24.65px;
		margin-right: 16px;
	}


	-webkit-touch-callout: none;
    -webkit-user-select: none;
	-khtml-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
`;

export const Text = styled.p`
	${({ size }) => getFontSize(size || 16)};
	font-weight: ${({ weight }) => weight};
	margin: ${({ margin }) => margin || '0'};
	color: ${({ textColor }) => textColor || color.dark};

	@media (min-width: 1920px) {
		${({ sizeDesktop }) => sizeDesktop && getFontSize(sizeDesktop)};
	}
`;

const card = css`
	border-radius: 8px;
	overflow: hidden;
	margin: ${({ margin }) => margin};
	position: relative;
	box-shadow: ${`0 2px 2px ${color.shadow}`};
	@media screen and (min-width: ${mediaQuery.laptop}px) {
		height: 360px;
	}
	@media screen and (min-width: ${mediaQuery.desktop}px) {
		height: calc(360px * 1.5);
	}
`;

export const VideoCard = styled.div`
	${card}
	@media screen and (min-width: ${mediaQuery.laptop}px) {
		width: calc(100% - 352px);
	}
	@media screen and (min-width: ${mediaQuery.desktop}px) {
		width: calc(100% - calc(calc(322 * 1.5) + 30));
	}
`;

export const ThumbnailCard = styled.div`
	${card}
	background-image: ${({ backgroundimage }) => `url("${backgroundimage}")`};
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
	@media screen and (min-width: ${mediaQuery.laptop}px) {
		width: calc(100% - 600px);
	}
	@media screen and (min-width: ${mediaQuery.desktop}px) {
		width: calc(322 * 1.5);
	}
`;

export const TvCard = styled.div`
	@keyframes cardOut {
		0% {
			transform: translateX(0);
			opacity: 1;
		}
		100% {
			transform: translateX(15px);
			opacity: 0;
		}
	}
	@keyframes cardIn {
		0% {
			transform: translateY(-15px);
			opacity: 0;
		}
		100% {
			transform: translateY(0);
			opacity: 1;
		}
	}
	@keyframes appear {
		0% { opacity: 0; }
		100% { opacity: 1; }
	}

	background-color: ${color.lightGray};
	min-width: 300px;
	padding: 30px;
	margin-left: 32px;
	border-radius: 8px;
 	& .inner {
		animation: cardIn 0.5s;
	}
	& .tvcard {
		display: flex;
		flex-direction: column;
		&:not(:nth-last-of-type(1)) {
			margin-bottom: 22px;
		}
	}
	-webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
	user-select: none;
	
	svg {
		cursor: pointer;
		fill: ${color.dark2};
	}

	.disabled {
		cursor: default;
		fill: ${color.gray};
	}
`;

export const Material = styled.a`
	font-size: 12px;
	color: #2E2D37;
	margin-right: 20px;
	font-weight: 600;
	:hover {
		opacity: 0.3;
		transition: 0.3s;
	}
`;


export const TvCardTitle = styled.h3`
	${getFontSize(21)}
	margin: 0;
	font-weight: ${fontWeight.bold};
	margin-bottom: 22px;
`;

export const TvCardText = styled.p`
	${getFontSize(21)}
	margin: 0;
	font-weight: ${fontWeight.bold};
`;

export const TvCardLabel = styled.span`
	${getFontSize(21)}
	margin-bottom: 8px;
`;

export const TvCardLogo = styled.img`
	max-height: 30px;
	margin-right: 10px;
`;
